var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"type-detail",class:_vm.color,on:{"mouseover":_vm.handleMouseOver,"click":_vm.handleClick}},[_c('canvas',{ref:"detail",attrs:{"resize":"true"}})])}
var staticRenderFns = []

export { render, staticRenderFns }